import Failure from "../../../core/Failure";
import HttpClient from "../../../core/HttpClient";
import { Authentication } from '@leedpulse-monorepo/classes';

async function migrateContactsFromAnotherUser(oldOwnerUid: string, newOwnerUid: string, scenarioId: string, auth: Authentication): Promise<void> {
  try {
    await HttpClient.post(
      '/users/migrate/contacts',
      {
        oldOwnerUid,
        newOwnerUid,
        scenarioId
      },
      auth.token,
      false
    );
    return;
  } catch (e) {
    console.log("error: ", e);
    throw new MigrateContactsFromAnotherUserFailure();
  }
}

export class MigrateContactsFromAnotherUserFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default migrateContactsFromAnotherUser;
